import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { injectIdentityProviderId } from "@utils/parameter-injector";
import { RequestTypes } from "@enums/request-types";
import { IdentityProviderConfiguration } from "@idw-types/data/identity-providers";

export const exportIdentityProviderConfigurationRequest = async (
    identityProviderId: string
): Promise<{ data: IdentityProviderConfiguration, error: any }> => {
    const route = injectIdentityProviderId(apiRoutes.idpConfiguration.identityProviderConfig.identityProvider.export, identityProviderId);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error }
};